import { io } from "socket.io-client"

class SocketService {
  constructor() {
    this.socket = null
    // Warteschlange für Listener, die registriert werden, bevor der Socket verbunden ist
    this.pendingListeners = []
  }

  connect() {
    if (this.socket) {
      // Bereits initialisiert (muss nicht zwingend 'connected' sein,
      // socket.io managed Reconnects selbst)
      return
    }

    const authToken = localStorage.getItem("token")

    if (!authToken) {
      console.error("❌ SocketService: Kein Token gefunden, Abbruch.")
      return
    }

    // 2. Verbindung aufbauen
    this.socket = io({
      path: "/api/live/",
      auth: {
        token: authToken,
      },
      // Wichtig für Stabilität:
      reconnection: true,
      reconnectionAttempts: 10,
      reconnectionDelay: 1000,
      transports: ["websocket", "polling"], // Fallback sicherstellen
    })

    // --- SYSTEM EVENTS ---

    this.socket.on("connect", () => {
      console.log(`✅ WebSocket verbunden! ID: ${this.socket.id}`)

      // Warteschlange abarbeiten: Listener registrieren, die während des Ladens gesetzt wurden
      this.flushPendingListeners()
    })

    this.socket.on("connect_error", (err) => {
      console.error(`⚠️ WebSocket Verbindungsfehler: ${err.message}`)
      // Optional: Bei Token-Fehler Logout triggern
      /* if (err.message.includes("Authentifizierung")) { logout(); } */
    })

    this.socket.on("disconnect", (reason) => {
      console.warn(`🔌 WebSocket getrennt: ${reason}`)
    })
  }

  disconnect() {
    if (this.socket) {
      this.socket.disconnect()
      this.socket = null
    }
  }

  /**
   * Registriert einen Event-Listener.
   * Wenn der Socket noch nicht da ist, wird der Listener in eine Warteschlange gepackt.
   */
  on(eventName, callback) {
    if (this.socket) {
      this.socket.on(eventName, callback)
    } else {
      // Noch nicht verbunden? Merken für später!
      console.log(`⏳ Socket noch nicht bereit, queue Listener für: ${eventName}`)
      this.pendingListeners.push({ type: "on", eventName, callback })
    }
  }

  /**
   * Entfernt einen Event-Listener.
   * WICHTIG: Callback muss übergeben werden, um nicht alle Listener zu löschen!
   */
  off(eventName, callback) {
    if (this.socket) {
      if (callback) {
        this.socket.off(eventName, callback)
      } else {
        this.socket.off(eventName) // Fallback: Alle entfernen
      }
    }

    // Falls er noch in der Warteschlange war und wir ihn abmelden wollen bevor connected wurde
    this.pendingListeners = this.pendingListeners.filter((l) => !(l.eventName === eventName && l.callback === callback))
  }

  /**
   * Sendet ein Event (Emit)
   */
  emit(eventName, data) {
    if (this.socket && this.socket.connected) {
      this.socket.emit(eventName, data)
    } else {
      console.log(`⏳ Socket noch nicht bereit, queue Emit für: ${eventName}`)
      // Optional: Auch Emits queuen, falls nötig
    }
  }

  /**
   * Interne Methode: Arbeitet die Warteschlange ab, sobald Connected
   */
  flushPendingListeners() {
    if (!this.socket) return

    while (this.pendingListeners.length > 0) {
      const listener = this.pendingListeners.shift() // Erstes Element holen
      if (listener.type === "on") {
        this.socket.on(listener.eventName, listener.callback)
        console.log(`🔄 Queued Listener registriert für: ${listener.eventName}`)
      }
    }
  }
}

// Singleton-Instanz exportieren
export default new SocketService()
